import { CoinHistoryTable } from './CoinHistoryTable'
import withCoinHistoryTable from './withCoinHistoryTable'

const ConnectedCoinHistoryTable = withCoinHistoryTable(CoinHistoryTable)
export { ConnectedCoinHistoryTable as CoinHistoryTable }
